module.exports = __webpack_public_path__ + "bb61cd2ad18dd89c2baa91db289d8188.png";